import React, { useState } from 'react';
import { CloseOutlined, DeleteOutlined, DoubleLeftOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, PrinterOutlined, RollbackOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Search_Parking_Reserve_Api } from '../../API/ParkingReserveApi';

// تابع کمکی برای تبدیل کاراکترهای فارسی به لاتین
const persianToLatinDigits = (str) => {
  if (!str) return '';
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const latinDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  let newStr = str;
  for (let i = 0; i < 10; i++) {
    const regex = new RegExp(persianDigits[i], 'g');
    newStr = newStr.replace(regex, latinDigits[i]);
  }
  return newStr;
};

// تابع کمکی برای تبدیل DateObject به رشته با فرمت و اعداد لاتین برای API
const formatDateForApi = (dateObject) => {
  if (!dateObject) return '';
  const formattedDate = dateObject.format('YYYY-MM-DD');
  return persianToLatinDigits(formattedDate);
};

// ======================================================================

export const ParkingComponent = ({ setLoading, showMessage, categoryId, onBackClick }) => {
  // ======================================================================
  const [dateShamsi, setDateShamsi] = useState(null);
  const [parkings, setParkings] = useState(null);

  // ======================================================================
  const submitSearch = async () => {
    if (!dateShamsi) {
      showMessage("لطفا تاریخ را وارد کنید.", "error");
      return;
    }

    setLoading(true);
    try {
      const params = {
        date_Shamsi: dateShamsi,
        categoryId: categoryId,
      };
      
      const data = await Search_Parking_Reserve_Api(params);
      
      if (data.messageStatus === "Successful") {
        setParkings(data.messageData.data);
      } else {
        showMessage(data.message, "error");
      }
    } catch (error) {
      console.error("Error in submitSearch:", error);
      showMessage("خطا در ارتباط با سرور.", "error");
    } finally {
      setLoading(false);
    }
  };

  // ======================================================================
  return (
    <>
      <Row className='sectionTitle' style={{ marginBottom: '10px' }}>
        <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }}>
          <Button
            className='step-prev-btn btn-light'
            onClick={onBackClick}
          >
            <DoubleRightOutlined />
            <span className='step-prev-btn-title'>
              بازگشت
            </span>
          </Button>
        </Col>
        <Col xs={10} sm={10} md={10} lg={16} xl={16}>
          <h2>
            گزارشات پارکینگ
          </h2>
        </Col>
      </Row>

      <div className='container'>
        <Row align="middle" gutter={[16, 16]}>
          <Col xs={24} sm={12} md={3} lg={2} xl={2} style={{ fontWeight: 'bold' }}>
            تاریخ:
          </Col>
          <Col xs={24} sm={12} md={9} lg={5} xl={5}>
            <DatePicker
              placeholder="تاریخ"
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              onChange={(dateObject) => setDateShamsi(formatDateForApi(dateObject))}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={17} xl={17} style={{ textAlign: 'right' }}>
            <Button 
              className='btn-success' 
              onClick={submitSearch} 
              style={{ width: '120px' }}
            >
              <SearchOutlined /> جستجو
            </Button>
          </Col>
        </Row>
      </div>
      
      {parkings && parkings.length > 0 ? (
        <div className='container factor' style={{ marginTop: '20px' }}>
          <Row className="titleRow">
            <Col span={8} className="titleColumn">
              نام و نام خانوادگی
            </Col>
            <Col span={8} className="titleColumn">
              نام اتاق
            </Col>
            <Col span={8} className="titleColumn">
              تعداد پارکینگ
            </Col>
          </Row>
          {parkings.map((item, index) => (
            <Row className="valueRow" key={index}>
              <Col span={8} className="valueTitle">
                {item.fullName}
              </Col>
              <Col span={8} className="valueTitle">
                {item.objectInstanceTitle}
              </Col>
              <Col span={8} className="valueColumn">
                {item.count}
              </Col>
            </Row>
          ))}
        </div>
      ) : parkings && parkings.length === 0 ? (
        <div className='container' style={{ marginTop: '20px', textAlign: 'center' }}>
          گزارشی برای تاریخ انتخاب شده یافت نشد.
        </div>
      ) : null}
    </>
  );
};